import {
  IFeatureTicker,
  IFeatureTickerFields,
  ISocialProofBar,
  ISocialProofBarFields
} from '@/types/contentful';
import React from 'react';
import FeatureTicker from '../FeatureTicker';
import { SocialProofBar } from '../SocialProofBar';

type IAdditionalContent = ISocialProofBar | IFeatureTicker | undefined;

interface ContentComponentProps {
  additionalContent: IAdditionalContent | null;
}

const AdditionalContent: React.FC<ContentComponentProps> = ({
  additionalContent
}) => {
  if (!additionalContent) return null;

  const { sys, fields } = additionalContent;

  switch (sys?.contentType?.sys?.id) {
    case 'socialProofBar':
      return <SocialProofBar {...(fields as ISocialProofBarFields)} />;
    case 'featureTicker':
      return <FeatureTicker {...(fields as IFeatureTickerFields)} />;
    default:
      return null; // Or some fallback UI
  }
};

export default AdditionalContent;
